// extracted by mini-css-extract-plugin
export default {"removeUserModal":"IbM4cb6BbnuCMlEgArqI","modalHeader":"A6Nl9DuEAA1D8eNQJ1ev","modalContent":"kDvmyiQfY0EdEQ3cUTNb","confirmActions":"q395kniDJS6dJ1qhcNVA"};